import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/rest/scopes/auths/login',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/rest/scopes/auths/profile',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/rest/scopes/auths/logout',
    method: 'get'
  })
}
